import { useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'
import { useMasterAdmin } from '../contexts/MasterAdminContext'
import Card from './Card'
import { ShieldOff, Loader2 } from 'lucide-react'

const MasterAdminProtectedRoute = ({ children }) => {
  const { isMasterAdmin, loading } = useMasterAdmin()

  if (loading) {
    return (
      <div className="section-container">
        <div className="flex items-center justify-center py-12">
          <Loader2 className="animate-spin text-primary-600" size={32} />
        </div>
      </div>
    )
  }

  if (!isMasterAdmin) {
    return (
      <div className="section-container">
        <Card variant="soft" className="p-12 text-center">
          <ShieldOff size={48} className="mx-auto mb-4 text-red-400" />
          <h3 className="text-xl font-semibold text-gray-900 mb-2">Access Denied</h3>
          <p className="text-gray-600 mb-6">
            You do not have master admin privileges. This area is restricted to platform administrators only.
          </p>
          <Navigate to="/dashboard" replace />
        </Card>
      </div>
    )
  }

  return children
}

export default MasterAdminProtectedRoute

